import DefaultCarousel from './DefaultCarousel';
import ExpandingDetailTile from '../tiles/ExpandingDetailTile';
import { LaneItem } from 'services/cwData';

export default class SearchCarousel extends DefaultCarousel {
  override useHighlightFocus() {
    return false;
  }

  override getImageUrl(item: LaneItem) {
    if (item.customImageUrl) return item.customImageUrl;

    return undefined;
  }

  $expandDetailTile(shouldExpand: boolean) {
    const newHeight = shouldExpand
      ? ExpandingDetailTile.expandedHeight + this.rowListOffset
      : ExpandingDetailTile.height + this.rowListOffset;

    this.h = newHeight;
    this.signal('onCarouselHeightChanged', this, shouldExpand);
  }

  override onGlobalHoverEnabled() {
    super.onGlobalHoverEnabled();

    if (!this.hovered) {
      this.$expandDetailTile(false);
    }
  }

  override onGlobalHoverDisabled() {
    super.onGlobalHoverDisabled();

    if (this.hasFocus()) {
      this.$expandDetailTile(true);
    }
  }
}
